<div class="alert-container">
    <div class="custom-alert p-3 d-flex flex-column align-items-center" [ngClass]="status == true ? 'correct' : 'incorrect'">
        <div class="icon-circle" [ngClass]="status == true ? 'correct' : 'incorrect'">
            <span class="icon" [class]="iconClass"></span>
        </div>
        <span class="text-center font-weight-bold">{{alertMessage}}</span>
    </div>
</div>